import client from '../utils/fetch-client';

const path = '/v2/applications';

export default {
	createApplication() {
		return client.post(`${path}`);
	},
};
